import React from 'react'
import { Box, Button, Tooltip } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { SETTLEMENT_APPROVAL_BUTTON_LABEL } from '../../constants/settlementActionConstants'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
  UI_COLOR_WHITE
} from '../../constants/uiColors'

export default function SettlementApprovalButton({
  disabled = false,
  tooltip = '',
  onClick
}) {
  return (
    <Tooltip title={tooltip}>
      <span>
        <Button
          variant="contained"
          disabled={disabled}
          onClick={onClick}
          sx={{
            height: 36,
            minWidth: 200,
            pl: 1,
            pr: 2,
            backgroundColor: UI_COLOR_ACCENT_ORANGE,
            color: UI_COLOR_WHITE,
            borderRadius: 1,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.22)',
            fontSize: 13,
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: UI_COLOR_ACCENT_ORANGE_ALT_HOVER,
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.22)'
            }
          }}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              transform: 'translateX(-2px)'
            }}
          >
            <Box component="span" sx={{ display: 'inline-flex', justifyContent: 'center' }}>
              <CheckIcon sx={{ fontSize: 20  }} />
            </Box>
            <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
              {SETTLEMENT_APPROVAL_BUTTON_LABEL}
            </Box>
          </Box>
        </Button>
      </span>
    </Tooltip>
  )
}
